




































import {
  deleteExpenseCategory,
  ExpenseCategory,
  getExpenseCategories
} from "@/api/cost/expense-categories-api";
import { Component, Vue } from "vue-property-decorator";
import { EXPENSE_CATEGORIES_READONLY } from "@/preferences";

@Component({ components: {} })
export default class ExpenseCategoryListPage extends Vue {
  fields = [
    {
      key: "name",
      label: "カテゴリ名"
    },
    { key: "important", label: "詳細表示" },
    { key: "actions", label: " " }
  ];

  expenseCategories: ExpenseCategory[] = [];

  get items() {
    return this.expenseCategories.map(category => ({
      id: category.id,
      name: category.name,
      important: category.important ? "ON" : "OFF"
    }));
  }

  created() {
    this.initExpenseCategories();
  }

  async initExpenseCategories() {
    this.expenseCategories = await getExpenseCategories(true);
  }

  async destroy(id: string) {
    // TODO: 可能なら削除する項目の名前を表示
    if (!confirm("本当に削除してもよろしいですか？")) return;
    await deleteExpenseCategory(id);
    this.initExpenseCategories();
  }

  hideDestroyButton(categoryName: string) {
    return EXPENSE_CATEGORIES_READONLY.includes(categoryName);
  }
}
